<template>
    <table>
        <span class="count">{{goodsList.length}}</span>
        <tbody class="goods-tbody" ref="tbody">
            <tr class="goods-drag-item" :class="{ 'is-down': goods.status === 1 }" v-for="(goods, index) in list" :key="goods.id" :data-goods-id="goods.id">
                <td>
                    <el-checkbox :checked="true"></el-checkbox>
                </td>
                <td>{{index + 1}}</td>
                <!-- 商品名 -->
                <td>
                    <span class="text-popper">{{goods.name}}</span>
                </td>
                <!-- 所有分组 -->
                <td class="all-group">
                    <span class="text-popper" v-textPopper>{{getGoodsGroupName(goods)}}</span>
                </td>
                <!-- 售价 -->
                <td class="t-r">
                    <span class="text-popper" v-textPopper>{{goods.sale_price}}元/{{get(goods, 'sale_prices[0].sale_unit.name')}}</span>
                </td>
                <td></td>
                <!-- 商品编码 -->
                <td>
                    <span class="text-popper" v-textPopper>{{ goods.goods_code || '-' }}</span>
                </td>
                <!-- 操作 -->
                <td>
                    <button class="pl-0 text-btn" >详情</button>
                    <button class="text-btn" >编辑</button>
                </td>
                <div slot="image">
                    
                </div>
            </tr>
        </tbody>
    </table>
</template>

<script>
import Vue from 'vue'
import { createComponent } from '@vue/composition-api'
import get from 'lodash/get'
export default createComponent({
    props: {
        goodsList: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        list() {
            return this.goodsList.slice(0, 20)
        },

        get() {
            return get
        }
    },

    methods: {
        getGoodsGroupName(goods) {
            if (!goods.group) {
                return ''
            }
            let str = goods.group.name
            if (goods.secondary_group.name) {
                str += '/' + goods.secondary_group.name
            }
            return str
        }
    }
})
</script>

<style lang="scss" scoped>
// 表格样式代码开始 --------------------------------------------------
table {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 800px !important;

    .count {
        position: absolute;
        left: -12px;
        top: -12px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #ee5b5b;
        color: #fff;
    }

    .t-r {
        text-align: right;
    }

    .t-l {
        text-align: left;
    }

    .t-c {
        text-align: center;
    }

    tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        border-top: 1px solid #EBEBEB;
        border-bottom: 1px solid #EBEBEB;

        &:nth-of-type(1) {
            border-top: none;
        }

        td:nth-of-type(2) {
            color: #333;
        }

        &.is-down {
            color: #999;
        }
    }

    // 单元格宽度定义开始 ----------------------------------
    @mixin tableCellWidth {
        &.all-group {
            width: 200px;
            text-align: right;
        }

        &:nth-of-type(1) {
            width: 20px;
        }

        &:nth-of-type(2) {
            width: 36px;
        }

        &:nth-of-type(3) {

        }

        &:nth-of-type(4) {

        }

        &:nth-of-type(5) {

        }

        // &:nth-last-child(4) {
        //     width: 120px;
        // }

        &:nth-last-child(3) {
            width: 20px;
        }

        &:last-of-type {
            width: 105px;
        }
    }
    // 单元格宽度定义结束 ----------------------------------

    thead {
        font-weight: bold;
        font-size: 14px;

        td {
            @include tableCellWidth;
        }

        td {
            padding: 12px;
            line-height: 20px;
            color: #999999 !important;
        }
    }

    tbody {
        flex: 1;
        display: block;
        table-layout: fixed;
        overflow-y: auto;
        height: 100%;
        width: 100%;

        tr {
            height: 44px;
            line-height: 44px;
            border-bottom: none;
            font-size: 14px;
            color: #333333;
            background: #fff;

            &:hover {
                background-color: #f5f7fa;
            }
        }
        
        td {
            @include tableCellWidth;
        }

        td {
            box-sizing: border-box;
            padding: 0 12px;
            vertical-align: middle;

            ::v-deep .el-checkbox__label{
                display: none;
            }
        }
    }

    tfoot {
        // display: block;
        // height: 44px;
        border-top: 1px solid #EBEBEB;

        tr {
            
            border: none;
        }

        td {
            padding: 7px 12px;
            padding-left: 146px;
        }
    }
}
// 表格样式代码结束 --------------------------------------------------
</style>